import { GIFTING_CATEGORY_MENU_REGION } from '../GiftingCategoryMenu/giftingCategoryMenuBrandRefreshClasses';

/** Fallback hero copy when no Braze HeroIntroPromo card matches this page. */

export const GIFTING_HERO_CATEGORY_SCROLL_LINK = `#${GIFTING_CATEGORY_MENU_REGION}`;

/** Matches hero CSS breakpoint for stacked / absolute mobile layout */
export const GIFTING_HERO_MOBILE_LAYOUT_MAX_WIDTH = 991;

/** Two-line headline on narrow viewports (desktop uses three lines). */
export const GIFTING_HERO_HEADLINE_LINES_MOBILE = ['The gift that', 'shows up warm.'];

export const GIFTING_HERO_DEFAULT = {
  headlineLines: ['The gift', 'that shows', 'up warm.'],
  preheader: 'Need it there tonight?',
  body: 'Send something sweet to their door in as little as an hour.',
  ctaText: 'Find a Gift Now',
  ctaLink: GIFTING_HERO_CATEGORY_SCROLL_LINK,
  ctaButtonType: 'internal_link',
  contentSection: 'Gifting LP — Hero',
};
export const GIFTING_HERO_MARQUEE_ITEMS = [
  { id: 'flavors', label: 'Over 50 flavors', iconKey: 'cookie' },
  { id: 'warm', label: 'Delivered warm', iconKey: 'delivery' },
  { id: 'corporate', label: 'Bulk & corporate gifting', iconKey: 'gift' },
];
